import type { ReactNode } from 'react';

import { Box, Text, useMantineTheme } from '@mantine/core';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';
import CheckIcon from '../../../assets/check.svg?react';

interface BlockTitleProps {
  depth: ResponseProjectBlock['depth'];
  title: string;
  isOpen: boolean;
  isCompleted: boolean;
  sideElement?: ReactNode;
}

export function BlockTitle({
  depth,
  title,
  isOpen,
  isCompleted,
  sideElement,
}: BlockTitleProps) {
  if (depth === 1) {
    return (
      <Text
        size="md"
        color={isOpen ? 'primary.7' : 'gray.9'}
        fw={isOpen ? 600 : 400}
        sx={{
          transition: 'all 0.2s ease-in-out',
        }}
      >
        {title}

        <SideElement sideElement={sideElement} isCompleted={isCompleted} />
      </Text>
    );
  }

  return (
    <Text size="sm" color={'gray.9'} fw={600}>
      {title}

      <SideElement sideElement={sideElement} isCompleted={isCompleted} />
    </Text>
  );
}

function SideElement({
  sideElement,
  isCompleted,
}: {
  sideElement: ReactNode;
  isCompleted: boolean;
}) {
  const theme = useMantineTheme();
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        transform: 'translateY(3px) translateX(4px)',
        gap: 4,
      }}
    >
      {isCompleted && (
        <CheckIcon
          fill={theme.colors.teal[5]}
          style={{
            minWidth: '16px',
            width: '16px',
            height: '16px',
          }}
        />
      )}
      {sideElement}
    </Box>
  );
}
